import FormInputText from './../Partials/FormInputText';
import FormInputUpload from './../Partials/FormInputUpload';
import FormInputTextArea from './../Partials/FormInputTextArea';
import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const InviteFriendsPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "heading",
                    partial: {
                        handler: FormInputText,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "heading");
                            },
                            required: true,
                            label: "سر صفحه"
                        }
                    }
                },
                {
                    field: "description",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description");
                            },
                            required: true,
                            label: "توضیحات",
                            textSize: 7
                        }
                    }
                },
                {
                    field: "image",
                    partial: {
                        handler: FormInputUpload,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "image");
                            },
                            required: false,
                            label: "عکس پس زمینه امتیاز",
                            direction: "ltr"
                        }
                    }
                },
                {
                    field: "description2",
                    partial: {
                        handler: FormInputTextArea,
                        props: {
                            initialValue: (formHandler) => {
                                return formHandler.getArrayInputValue("contents", "description2");
                            },
                            required: false,
                            label: "توضیحات زیر امتیاز",
                            textSize: 7
                        }
                    }
                },
            ]
        }
    }
};

export default InviteFriendsPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/InviteFriendsPageBuilder.js